module.exports = __webpack_public_path__ + "static/pattern-mobile-53e7bcb4b33110455f929992a6bb3369.jpg";